// extracted by mini-css-extract-plugin
module.exports = {"root":"PlaceSearch_root__3DPGj","options_menu":"PlaceSearch_options_menu__1ookG","option":"PlaceSearch_option__6FDHS"};